  // Handle scroll prevention for customer cards container
  export const handleWheel = (e) => {
    const container = e.currentTarget;
    const { scrollTop, scrollHeight, clientHeight } = container;
    
    // Always prevent default scroll behavior when scrolling within the container
    e.preventDefault();
    e.stopPropagation();
    
    // Manually handle the scroll
    const delta = e.deltaY;
    container.scrollTop += delta;
  };

  // Handle mouse enter to prevent body scroll
  export const handleMouseEnter = () => {
    document.body.style.overflow = 'hidden';
  };

  // Handle mouse leave to restore body scroll
  export const handleMouseLeave = () => {
    document.body.style.overflow = 'auto';
  };